module.exports = __webpack_public_path__ + "img/form-settings-text-oustside.58cdb688.svg";